import { isPlatformBrowser } from '@angular/common';
import { computed, Inject, Injectable, OnDestroy, PLATFORM_ID, signal } from '@angular/core';
import { debounceTime, fromEvent, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScreenService implements OnDestroy {
  width = signal<number>(0);
  height = signal<number>(0);

  orientation = signal<string>('portrait'); // 'portrait' or 'landscape'

  private mobileBreakpoint = 768;
  private desktopBreakpoint = 992;

  // Computed signals to determine the screen size category
  isMobile = computed(() => {
    const width = this.width();
    const orientation = this.orientation();

    if (orientation === 'portrait') {
      return width < this.desktopBreakpoint;
    } else {
      return width < this.mobileBreakpoint;
    }
  });

  isDesktop = computed(() => {
    return !this.isMobile()
  });

  private resizeSubscription!: Subscription;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      this.updateDimensions();

      this.resizeSubscription = fromEvent(window, 'resize')
        .pipe(debounceTime(100))
        .subscribe(() => {
          this.updateDimensions();
        });
    }
  }

  private updateDimensions() {
    this.width.set(window.innerWidth);
    this.height.set(window.innerHeight);
    this.orientation.set(window.innerHeight > window.innerWidth ? 'portrait' : 'landscape');
  }

  ngOnDestroy() {
    if (this.resizeSubscription) {
      this.resizeSubscription.unsubscribe();
    }
  }
}

